import { useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { RowFilterConditionOrNil } from '@qre-mailing/smart-table';

import { postSampleByQreIdStatus } from '../api/generated-evs/sdk.gen';

const emptyStatus = { lastUpdated: null as string | null, size: 0, totalSize: 0 };

export const useSampleStatus = (
  qreId: string,
  filter: RowFilterConditionOrNil,
  { lastUpdated, totalSize }: { lastUpdated: string | null; totalSize: number },
  enabled = true
) => {
  const lastOk = useRef<{ lastUpdated: string | null; size: number; totalSize: number } | null>(null);

  return useQuery({
    queryKey: ['sampleStatus', qreId, filter],
    queryFn: async () => {
      const result = await postSampleByQreIdStatus({
        path: { qreId },
        body: {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          conditionsGroup: filter as any,
          lastUpdated,
          totalSize,
        },
        throwOnError: false,
      });
      const status = (result as { response?: { status?: number } })?.response?.status;
      const data = (result as { data?: { lastUpdated: string | null; size: number; totalSize: number } })?.data;

      if (status && status >= 400) {
        throw (result as { error?: unknown })?.error ?? new Error(`Status ${status}`);
      }
      if (status === 304) {
        return lastOk.current ?? emptyStatus;
      }
      if (data) {
        lastOk.current = data;
      }
      return data ?? lastOk.current ?? emptyStatus;
    },
    enabled,
    refetchInterval: 3000,
    refetchIntervalInBackground: false,
  });
};
